import { Routes } from "@angular/router";

import { StarterViewComponent } from "./views/appviews/starterview.component";
import { LoginComponent } from "./views/appviews/login.component";
import { CambioPassComponent} from "./cambio-pass/cambio-pass.component";
import { NewPasswordComponent} from "./new-password/new-password.component";
import { BlankLayoutComponent } from "./components/common/layouts/blankLayout.component";
import { BasicLayoutComponent } from "./components/common/layouts/basicLayout.component";
import { TopNavigationLayoutComponent } from "./components/common/layouts/topNavigationlayout.component";
import { MiCuentaComponent } from "./mi-cuenta/mi-cuenta.component";
import { ObrasComponent } from "./obras/obras.component";
import { CertificadosComponent} from "./certificados/certificados.component";
import { ResultadoComponent} from "./resultado/resultado.component";
import { PopupComponent } from "./popup/popup.component";






export const ROUTES: Routes = [
  // Main redirect
  { path: '', redirectTo: 'starterview', pathMatch: 'full' },
  {
    path: '', component: BasicLayoutComponent,
    children: [
      { path: 'starterview', component: StarterViewComponent }
     
    ]
  },
  {
    path: '', component: BlankLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      {path: 'cambio-pass', component: CambioPassComponent},
      {path: 'new-pass', component: NewPasswordComponent}

    ]
  },
  {
    path: '', component: BasicLayoutComponent,
    children: [

      {path:'R-hormigones',component  : ObrasComponent}

    ]
  },
  {
    path: '', component: BasicLayoutComponent,
    children: [

      {path:'Certificados',component  : CertificadosComponent}

    ]
  },
  {
    path: '', component: BasicLayoutComponent,
    children: [

      {path:'Mi-cuenta',component  : MiCuentaComponent}

    ]
  },
  {
    path: '', component: BasicLayoutComponent,
    children: [
      {path: 'Resultado', component : ResultadoComponent}

    ]
  },
  {
    path: '', component: BasicLayoutComponent,
    children: [
      {path: 'Popup', component : PopupComponent}

    ]
  },



  // Handle all other routes
  { path: '**', redirectTo: 'starterview' }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts